import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-unit-no',
    templateUrl: './unit-no.component.html',
    styleUrls: ['./unit-no.component.css']
})
export class UnitNoComponent implements OnInit {

    constructor() { }
    @Input() unit: string;
    ngOnInit() { }

    get isNum() {
        return /[0-9]+/.test(this.unit || '');
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/components/unit-no/unit-no.component.ts